import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js'

export default class CartLineQuantityUpdatorCatalogue extends HTMLInputElement {
    constructor() {
        super();

        this.setAttribute('is', 'cart-line-quantity-updator-catalogue');

        this.productId = this.dataset.productId;
        this.catalogueId = this.dataset.catalogueId;
        this.returnTemplates = JSON.parse(this.dataset.returnTemplates ?? '[]');
        this.mainContainer = document.getElementById('main-container');
    }

    connectedCallback() {
        this.watch();
    }

    disconnectedCallback() {
        this.unwatch();
    }

    watch() {
        this.addEventListener('change', this.updateQuantity.bind(this));
    }

    unwatch() {
        this.removeEventListener('change', this.updateQuantity);
    }

    updateQuantity() {
        const quantity = parseInt(this.value);

        // Si on vient de la vue panier
        if (this.dataset.viewCart) {
            if (!quantity) {
                if (quantity === 0) {
                    // Stocker une référence à this pour l'utiliser dans le callback
                    const self = this; // Utiliser const au lieu de var

                    // swal confirmation pour supprimer l'item du panier
                    swal.fire({
                        title: 'Êtes-vous sûr de vouloir supprimer cet article du panier ?',
                        icon: 'danger',
                        showCancelButton: true,
                        confirmButtonText: 'Oui, supprimer',
                        cancelButtonText: 'Annuler',
                    })
                        .then((result) => {
                            if (result.value) {
                                const requestor = new Requestor();

                                requestor.sendRequest(self.dataset.href, 'PUT', {
                                    product_id: self.productId,
                                    quantity: quantity,
                                    catalogue_id: self.catalogueId,
                                    return_templates: self.returnTemplates,
                                }, (data) => {
                                    // On controle d'etre bien dans le panier pour mettre à jour les vues
                                    if (self.mainContainer && self.returnTemplates.length) {
                                        self.mainContainer.updateCartViews(data);
                                    }
                                });
                            } else {
                                // Si l'utilisateur annule, on remet la valeur précédente
                                // Refresh du template pour gestion des composants figés en valeur 0
                                const previousQuantity = parseInt(self.dataset.previousValue, 10) || 1;
                                const requestor = new Requestor();

                                requestor.sendRequest(self.dataset.href, 'PUT', {
                                    product_id: self.productId,
                                    quantity: previousQuantity,
                                    catalogue_id: self.catalogueId,
                                    return_templates: self.returnTemplates,
                                }, (data) => {
                                    // On controle d'etre bien dans le panier pour mettre à jour les vues
                                    if (self.mainContainer && self.returnTemplates.length) {
                                        self.mainContainer.updateCartViews(data);
                                    }
                                });
                            }
                        });
                }
            } else {
                const requestor = new Requestor();

                requestor.sendRequest(this.dataset.href, 'PUT', {
                    product_id: this.productId,
                    quantity: quantity,
                    catalogue_id: this.catalogueId,
                    return_templates: this.returnTemplates,
                }, (data) => {
                    // On controle d'etre bien dans le panier pour mettre à jour les vues
                    if (this.mainContainer && this.returnTemplates.length) {
                        this.mainContainer.updateCartViews(data);
                    }
                });
            }
        } else {
            if (! quantity) {
                return;
            }

            const requestor = new Requestor();

            requestor.sendRequest( this.dataset.href, 'PUT', {
                'product_id': this.productId,
                'quantity': quantity,
                'catalogue_id': this.catalogueId,
                'return_templates': this.returnTemplates,
            }, (data) => {
                // On controle d'etre bien dans le panier pour mettre à jour les vues
                if (this.mainContainer && this.returnTemplates.length) {
                    this.mainContainer.updateCartViews( data );
                }
            });

        }
    }
}
